import React, { useEffect, useRef } from 'react'
import Routers from './routes'
import { BrowserRouter, useLocation } from 'react-router-dom'
import GlobalStyle from 'theme/GlobalStyle'
import { identifyUser } from './utils/clarity'
import { identifyPostHogUser, initPostHog } from './utils/posthog'
import { routeHistory } from 'utils/routeHistory'

const { REACT_APP_POSTHOG_API_KEY } = process.env;
const { REACT_APP_POSTHOG_HOST } = process.env;
const { ENVIRONMENT } = process.env;

// Updates routeHistory synchronously during render so that sibling components
// rendered after this (inside <Routers>) can read routeHistory.prev correctly
// during the same render cycle — before any useEffect fires.
const RouteTracker = () => {
  const location = useLocation()
  const prevRef = useRef(null)

  if (prevRef.current !== location.pathname) {
    routeHistory.prev = prevRef.current
    routeHistory.current = location.pathname
    prevRef.current = location.pathname
  }

  return null
}

const App = ({ token, permissions, userData }) => {
  useEffect(() => {
    initPostHog(REACT_APP_POSTHOG_API_KEY, REACT_APP_POSTHOG_HOST);
  }, [])

  useEffect(() => {
    const email = userData?.email
    if (email) {
      identifyUser(email)
      identifyPostHogUser(email, {
        environment: ENVIRONMENT,
      })
    }
  }, [userData])

  return (
    <BrowserRouter>
      <GlobalStyle />
      <RouteTracker />
      <Routers token={token} permissions={permissions} />
    </BrowserRouter>
  )
}

export default App
